<template>
    <div>
        <div class="row mt-3 mb-3" v-if="!isLoading">
            <div class="col-12" v-if="entries.length">
                <b-form-group v-model="checked">
                    <b-form-checkbox-group
                        v-model="checked"
                        stacked
                    >
                        <b-form-checkbox
                            v-for="entry in translatedEntries"
                            :key="entry[entryKey]"
                            :value="entry.value"
                        >
                            <span class="break-word">{{ entry.label }}</span>
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </div>
        </div>
        <div class="row mt-3 mb-3" v-else>
            <div class="col-12">
                <div class="row ml-0"><b-skeleton width="20px" class="mr-2"></b-skeleton> <b-skeleton width="200px"></b-skeleton></div>
                <div class="row ml-0"><b-skeleton width="20px" class="mr-2"></b-skeleton> <b-skeleton width="180px"></b-skeleton></div>
                <div class="row ml-0"><b-skeleton width="20px" class="mr-2"></b-skeleton> <b-skeleton width="205px"></b-skeleton></div>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormGroup, BFormCheckbox, BFormCheckboxGroup, BFormSelect, BSkeleton } from "bootstrap-vue"
import { EventBus } from "../../event-bus"

export default {
    name: 'FilterCheckboxBox',
    components: {
        BFormGroup,
        BFormCheckboxGroup, BFormCheckbox, BFormSelect,
        BSkeleton
    },
    props: {
        entryKey: {
            type: String,
            default: 'id'
        },
        filterTitle: {
            Type: String
        },
        hideZero: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        return {
            changedByUrl: false,
            filterData: null,
            isLoading: true,
            checked: [],
            entries: []
        }
    },
    methods: {
        getFilterData(data){
            this.filterData = data.find(f => f.name === this.filterTitle)
            this.entries = this.filterData.values
            let oldDefault = null

            if(this.hideZero){
                oldDefault = this.entries.findIndex(o => o.value === 0);
            } else {
                oldDefault = this.entries.findIndex(o => o.value === -1);
            }

            if(oldDefault !== -1){
                this.entries.splice(oldDefault, 1)
            }
            if(this.$route.query[this.filterTitle]){
                this.changedByUrl = true
                let optionIds

                if(this.filterTitle =='vehicle_condition') {
                    optionIds = this.$route.query[this.filterTitle].replace(/[\[\]']+/g, '').split(',')
                } else {
                    optionIds = this.$route.query[this.filterTitle].replace(/[^-0-9\,]/g, '').split(',')
                }

                optionIds.forEach(value => {
                    this.checked.push(value)
                })
            }
            this.isLoading = false
        },
        resetFilter(){
            this.changedByUrl = true
            this.checked = []
        }
    },
    watch: {
        checked: function (val) {
            // fallback if order is set by url
            if(!this.changedByUrl){
                let string = ''

                this.checked.forEach(function(val, key, array){
                    string = (key === 0) ? val : `${string},${val}`
                })
                string = `[${string}]`

                EventBus.$emit('update-catalog-filter', {filter:this.filterTitle, value: string})
            } else {
                this.changedByUrl = false
            }
        },
    },
    computed: {
        translatedEntries(){
            let entries = []
            this.entries.forEach(entry =>{
                if(entry.label.split('.')[0] !== 'cat'){
                    entry.label = this.$t('cat.filter.' + entry.label)
                }
                entries.push(entry)
            })

            return entries
        }
    },
    mounted() {
        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-received-modal', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
